import http from '../http-common'

class SingpassService {
  async getAuthorizationUrl(sessionId, isGlobalDomain) {
    const response = await http.get(
      `/sp/authorizationUrl?sessionId=${sessionId}&isGlobalDomain=${isGlobalDomain}`
    )
    if (response.data.error) {
      throw new Error(response.data.error.message)
    }
    return response.data
  }

  async handleCallback(code, state, isGlobalDomain) {
    const response = await http.get(
      `/sp/callback?code=${code}&state=${state}&isGlobalDomain=${isGlobalDomain}`
    )
    if (response.data.error) {
      throw new Error(response.data.error.message)
    }
    return response.data
  }
}

export default new SingpassService()
